import React from 'react';
import { useReactFlow, getRectOfNodes, getTransformForBounds } from 'reactflow';
import { toPng } from 'html-to-image';
import './downloadButton.css';
import { ReactComponent as ExportLogo } from "../../assets/download-Image-icon.svg";


function downloadImage(dataUrl) {
  const a = document.createElement('a');

  a.setAttribute('download', 'MindMap.png');
  a.setAttribute('href', dataUrl);
  a.click();
}

const imageWidth = 1024;
const imageHeight = 768;

function DownloadButton() {
  const isMobile = window.screen.width < 768;
  const { getNodes } = useReactFlow();
  const onClick = () => {
    const nodesBounds = getRectOfNodes(getNodes());
    const transform = getTransformForBounds(nodesBounds, imageWidth, imageHeight, 0.5, 2);

    toPng(document.querySelector('.react-flow__viewport'), {
      backgroundColor: '#1a365d',
      width: imageWidth,
      height: imageHeight,
      style: {
        width: imageWidth,
        height: imageHeight,
        transform: `translate(${transform[0]}px, ${transform[1]}px) scale(${transform[2]})`,
      },
    }).then(downloadImage);
  };

  return (
    <div style={{ cursor: 'pointer', marginTop: '8px', marginLeft: '8px' }} title='Download image'>
      <ExportLogo style={{ width: isMobile ? 22 : 28 }} onClick={onClick} />
    </div>
  );
}

export default DownloadButton;